module.exports = __webpack_public_path__ + "banquet/components/Banquet/images/favicon.afa3de6771632498166ad66675491e36.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/images/favicon.png
// module id = 1661
// module chunks = 1